import { Store } from "react-notifications-component";

type NOTIFICATION_TYPE = 'success' | 'danger' | 'info' | 'default' | 'warning';

export function AlertNotify(props: { message: string; type?: NOTIFICATION_TYPE }) {
  try {
    // Lista de tipos válidos no pacote
    const validTypes: NOTIFICATION_TYPE[] = ['success', 'danger', 'info', 'default', 'warning'];

    // Garante que o type seja válido ou usa 'success'
    const notificationType: NOTIFICATION_TYPE =
      validTypes.includes(props.type as NOTIFICATION_TYPE) ? props.type! : 'success';

    Store.removeAllNotifications();

    return Store.addNotification({
      title: "Aviso!",
      message: props.message,
      type: notificationType,
      insert: "top",
      container: "top-center",
      animationIn: ["animate__animated", "animate__fadeIn"],
      animationOut: ["animate__animated", "animate__fadeOut"], // corrigido
      dismiss: {
        duration: 5000,
        onScreen: true,
        showIcon: true
      }
    });
  } catch (error) {
    console.error("Erro ao exibir notificação:", error);
  }
}
